module.exports = __webpack_public_path__ + "img/Devika Dharmaraj.45ecd5ad.jpeg";